import React, { useRef } from "react";

import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import classNames from "classnames";
import styled from "styled-components";

import { Tooltip } from "components/base";

const tooltip_text = "Toggle Cum + Forecast";

interface ForecastToggleProps {
  readonly isForecastToggleOn: boolean;
  readonly onToggle: () => void;
  readonly isFocused?: boolean;
  readonly onSelectRef?: (index: number, selectEl: Maybe<HTMLElement>) => void;
  readonly componentIndex?: number;
}

function ForecastToggle({
  isForecastToggleOn,
  onToggle,
  isFocused = false,
  onSelectRef,
  componentIndex = 0
}: ForecastToggleProps) {
  const toggleRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      onToggle();
    }
  };

  return (
    <Tooltip title={tooltip_text} placement="topRight">
      <Toggle
        ref={(el) => {
          toggleRef.current = el;
          if (onSelectRef) onSelectRef(componentIndex, el as HTMLElement);
        }}
        className={classNames("toolbar-item", {
          "keyboard-focused": isFocused
        })}
        tabIndex={0}
        data-testid="focus-forecast-toggle-btn"
        active={isForecastToggleOn}
        onClick={() => {
          onToggle();
          if (toggleRef.current) {
            toggleRef.current.blur();
          }
        }}
        onKeyDown={handleKeyDown}>
        <TrendingDownIcon fontSize="large" />
      </Toggle>
    </Tooltip>
  );
}

export default ForecastToggle;

const Toggle = styled.div`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${({ active }) => (active ? "var(--color-primary)" : "#fff")};
  border: 1px solid rgb(217, 217, 217);
  color: ${({ active }) => (active ? "#fff" : "rgb(162, 170, 173)")};
  cursor: pointer;

  &:hover {
    background-color: #fff;
    color: ${({ active }) => (active ? "var(--color-primary)" : "var(--color-text)")};
    border-color: var(--color-primary);
  }

  &:focus {
    outline: none;
  }
`;
